module.exports = __webpack_public_path__ + "img/KSAT25-45-1000-3-complete.fb324937.png";